import { Component, OnInit,ViewChild } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { Router} from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';


declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ReviewEmployee/ReviewEmployeeList.html'
})

export class ReviewEmployeeListComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public StageList: any = [];
    public PeriodList: any = [];
    public TeamList: any = [];
    public ReviewTemplateList: any = [];
    public ReviewEmployeeList : any = [];
    public ReviewTemplateId:any = null;
    public StageConst:any={};  
    public showLoader = false;
    public TemplateFilterFlag: any;
    filter: any = {PeriodId:null,TeamId:null,StageId:null};

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.StageConst.Setup=this.constants.enumReviewEmployeeStatus.Setup;
        this.StageConst.Locked=this.constants.enumReviewEmployeeStatus.Locked;
        this.StageConst.Reviewed=this.constants.enumReviewEmployeeStatus.Review;
        this.StageConst.Closed=this.constants.enumReviewEmployeeStatus.Closed;
        this.TemplateFilterFlag=JSON.parse(localStorage.getItem('ReviewFilters'));
        if(this.TemplateFilterFlag!=null && typeof this.TemplateFilterFlag != 'undefined'){
          this.filter=JSON.parse(localStorage.getItem('ReviewFilters'));
          localStorage.removeItem("ReviewFilters")
          }   
    }

    ngOnInit() {
        this.getPeriodList();
        this.getTeam();
        this.getStageList();
        this.getReviewTemplateList();
        this.getReviewEmployeeList();
    }

    ngAfterViewInit() {

        $(".date").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $(".dateYear").datetimepicker({
            format: 'YYYY',
            maxDate:moment().set({hour:0,minute:0,second:0,millisecond:0})
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public getPeriodList() {
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployeeList/GetPeriod', null).subscribe(
            data => {
                this.PeriodList = data["PeriodList"];
                this.PeriodList = this.PeriodList.filter( x => x.IsActive === true);
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getTeam(){
        this.showLoader=true;
       this._httpService.ajaxPost('ReviewEmployeeList/GetTeam', { "UserId":this.userDetail.SiteUserId}).subscribe(
           data => {
               this.TeamList = data["TeamList"];                
           },
            err =>{
           this.showLoader=false;
            this._sharedService.ShowMessage(this.constants.globalError);
           },
            
            () =>{
                this.showLoader=false;
         
               }
       );
   }
    
    public getStageList() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["ReviewStageType"] }).subscribe(
            data => {
                this.StageList = data["Parameter"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }


 public clearFilter() {
      
            this.filter =  {PeriodId:null,TeamId:null,StageId:null};
  }
    public getReviewTemplateList() {
        this.showLoader = true;
        
        var url ="ReviewEmployeeList/GetReviewTemplate";
         
        this._httpService.ajaxPost(url,{"UserId":this.userDetail.SiteUserId}).subscribe(
            data => {
                  
                  this.ReviewTemplateList = data["ReviewTemplateList"];

                  
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getReviewEmployeeList() {
        this.showLoader = true;
        var url ="ReviewEmployeeList/GetReviewEmployeeList";
         if(this.userDetail.RoleId == 3)
         {
               url = "ReviewEmployeeList/GetReviewTemplateEmployee";
                  
         }

         if(this.filter.PeriodId=="null")
             this.filter.PeriodId=null;
              if(this.filter.TeamId=="null")
             this.filter.TeamId=null;
                  if( this.filter.StageId=="null")
              this.filter.StageId=null;


        this._httpService.ajaxPost(url, { "PeriodId": this.filter.PeriodId, "TeamId": this.filter.TeamId, "StageId": this.filter.StageId ,"UserId":this.userDetail.SiteUserId}).subscribe(
            data => {
                this.ReviewEmployeeList = data["ReviewEmployeeList"];
                console.log("ReviewEmployeeList", this.ReviewEmployeeList)
                
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public setupKRA(isTemplate,employeeReviewId){
        
        this.filter = { 'PeriodId': this.filter.PeriodId,TeamId:this.filter.TeamId,StageId:this.filter.StageId};
        localStorage.setItem("ReviewFilters",JSON.stringify(this.filter));

        localStorage.setItem("IsTemplate",JSON.stringify(isTemplate));
        if(isTemplate == 1){
          //  if(this.ReviewTemplateId != null){
                this.ReviewTemplateId=0;
                localStorage.setItem("ReviewTemplateId",JSON.stringify(this.ReviewTemplateId));
                this._route.navigateByUrl("/setupKRA");
           // }
        }
        if(isTemplate == 2){
            if(employeeReviewId != null){
                localStorage.setItem("EmployeeReviewId",JSON.stringify(employeeReviewId));
                this._route.navigateByUrl("/setupKRA");
            }
        }
    }

    public printPDf(id,stageid){
          this.filter = { 'PeriodId': this.filter.PeriodId,TeamId:this.filter.TeamId,StageId:this.filter.StageId};
          localStorage.setItem("ReviewFilters",JSON.stringify(this.filter));
            localStorage.setItem("ReviewEmployeePrintId",JSON.stringify(id));
            localStorage.setItem("ReviewEmployeePrintStageId",JSON.stringify(stageid));
            
            this._route.navigateByUrl("/ReviewEmployeePrint");      
    }

    public reviewSheet(id){
        this.filter = { 'PeriodId': this.filter.PeriodId,TeamId:this.filter.TeamId,StageId:this.filter.StageId};
        localStorage.setItem("ReviewFilters",JSON.stringify(this.filter));
        localStorage.setItem("EmployeeReviewId",JSON.stringify(id));
        this._route.navigateByUrl("/reviewSheet");      
    }
         
        
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ReviewEmployee/ReviewEmployeeList.component.ts
 **/